import { render, staticRenderFns } from "./setGroup.vue?vue&type=template&id=9669f040&scoped=true&"
import script from "./setGroup.vue?vue&type=script&lang=js&"
export * from "./setGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9669f040",
  null
  
)

export default component.exports